import script from "./InfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoModal.vue?vue&type=script&setup=true&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=e1304d7e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1304d7e"]])

export default __exports__